import { create } from 'zustand';
import RouteUrls from '@/app/root/enums/RouteUrls';

/**
 * computedRoutes
 *
 * @returns Object listing computed routes objects
 */
function computeRoutes() {
    return Object.keys(RouteUrls).reduce(
        (acc, routeKey) => ({
            ...acc,
            [routeKey]: RouteUrls[routeKey]
        }),
        {}
    );
}

const useComputedRoutesStore = create(() => ({
    computedRoutes: computeRoutes()
}));

export default useComputedRoutesStore;